<template>
  <Modal @close="$emit('close')">
    <template #icon>
      <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
 class="w-5 h-5">
    <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
</svg>
      <!-- <svg
        class="w-5 h-5"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
        />
      </svg> -->
    </template>

    <template #header>
      <h1 class="font-semibold text-gray-900">
        {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.title') }}
      </h1>
    </template>

    <template #body>
      <div class="h-full w-full">
        <form
          action=""
          class="flex flex-col space-y-6"
          @submit.prevent=""
        >
          <!-- Personal Information Section -->
          <div class="space-y-4">
            <h3 class="text-sm font-medium text-gray-700 uppercase tracking-wide">
              {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.personalInformation') }}
            </h3>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-700">
                  {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.firstName') }}
                </label>

                <AppInput
                  v-model="laboursStore.filter.form.first_name"
                  type="text"
                  name="first_name"
                  data-test="filter-first-name"
                  class="form-input"
                  placeholder="First name"
                />
              </div>

              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-700">
                  {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.surname') }}
                </label>

                <AppInput
                  v-model="laboursStore.filter.form.last_name"
                  type="text"
                  name="surname"
                  data-test="filter-surname"
                  class="form-input"
                  placeholder="Surname"
                />
              </div>
            </div>
          </div>

          <!-- Company Information Section -->
          <div class="space-y-4">
            <h3 class="text-sm font-medium text-gray-700 uppercase tracking-wide">
              {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.companyInformation') }}
            </h3>

            <div class="space-y-4">
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-700">
                  {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.supplier') }}
                </label>

                <AppInput
                  v-model="laboursStore.filter.form.supplier_name"
                  type="text"
                  name="supplier"
                  data-test="filter-supplier-name"
                  class="form-input"
                  placeholder="Supplier name"
                />
              </div>

              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-700">
                  {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.vendorReference') }}
                </label>

                <AppTypeAhead
                  v-model="laboursStore.filter.form.vendor_ref"
                  name="vendor_ref"
                  :suggestion-callback="getSuggestions"
                  data-test="filter-vendor-ref"
                  class="form-input"
                  placeholder="Vendor reference"
                />
              </div>
            </div>
          </div>

          <!-- Date Range Section -->
          <div class="space-y-4">
            <h3 class="text-sm font-medium text-gray-700 uppercase tracking-wide">
              {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.dateRange') }}
            </h3>

            <div class="space-y-2">
              <p class="block text-sm font-medium text-gray-700">
                {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.recordDate') }}
              </p>

              <div class="flex items-center space-x-3 w-full">
                <div class="w-full">
                  <AppInput
                    v-model="laboursStore.filter.form.day_min"
                    name="day_min"
                    type="date"
                    class="form-input"
                  />
                </div>

                <div class="flex items-center space-x-2 text-gray-500">
                  <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
 class="w-4 h-4">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M17 8l4 4m0 0l-4 4m4-4H3"
    />
</svg>
                </div>

                <div class="w-full">
                  <AppInput
                    v-model="laboursStore.filter.form.day_max"
                    name="day_max"
                    type="date"
                    class="form-input"
                  />
                </div>
              </div>
            </div>
          </div>

          <!-- WBS Information Section -->
          <div class="space-y-4">
            <h3 class="text-sm font-medium text-gray-700 uppercase tracking-wide">
              {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.workBreakdownStructure') }}
            </h3>

            <div class="flex flex-col gap-4">
              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-700">
                  {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.wbsCode') }}
                </label>

                <AppSelect
                  v-model.number="laboursStore.filter.form.wbs_code_id"
                  :options="wbsCodes.map((code) => ({ value: code.id, label: code.code }))"
                  name="wbs_code"
                  data-test="wbs_code"
                  class="form-input"
                />
              </div>

              <div class="space-y-2">
                <label class="block text-sm font-medium text-gray-700">
                  {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.label.wbsDescription') }}
                </label>

                <AppSelect
                  v-model.number="laboursStore.filter.form.wbs_code_id"
                  :options="wbsCodes.map((code) => ({ value: code.id, label: code.description }))"
                  name="wbs_description"
                  data-test="wbs_description"
                  class="form-input"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </template>

    <template #footer>
      <div class="flex items-center space-x-3">
        <button
          type="button"
          class="inline-flex items-center px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
          @click="$emit('clear')"
        >
          <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
 class="w-4 h-4 mr-2">
    <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M6 18L18 6M6 6l12 12"
    />
</svg>
          {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.button.clear') }}
        </button>

        <button
          type="button"
          class="inline-flex items-center px-6 py-2 border border-transparent rounded-lg text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200 shadow-sm"
          data-test="apply-filter"
          @click="$emit('filter')"
        >
          <svg
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
 class="w-4 h-4 mr-2">
    <path
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"
    />
</svg>
          {{ $t('SelfPerform.LabourDashboard.LabourFilterModal.button.applyFilter') }}
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import Modal from '@/components/Modal.vue';
import { useLabourDailyRecordStore } from '@/store/labourDailyRecord';
import { useLaboursStore } from '@/store/labours';
import { useProjectsStore } from '@/store/projects';
import { useWbsCodesStore } from '@/store/wbsCodes';
import { computed } from 'vue';

defineEmits<{
  (e: 'close');
  (e: 'filter');
  (e: 'clear');
}>();

const laboursStore = useLaboursStore();
const projectsStore = useProjectsStore();

const project = computed(() => {
  return projectsStore.project;
});

const labourDailyRecordsStore = useLabourDailyRecordStore();
const wbsCodesStore = useWbsCodesStore();

const wbsCodes = computed(() => {
  return wbsCodesStore.models.where('project_id', project.value?.id).get();
});

const getSuggestions = () => {
  return labourDailyRecordsStore.search(project.value?.id, { vendor_ref: laboursStore.filter.form.vendor_ref });
};
</script>

<style scoped></style>
